import { render, staticRenderFns } from "./ClTask.vue?vue&type=template&id=1362eb0f&scoped=true&"
import script from "./ClTask.vue?vue&type=script&lang=ts&"
export * from "./ClTask.vue?vue&type=script&lang=ts&"
import style0 from "./ClTask.vue?vue&type=style&index=0&id=1362eb0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1362eb0f",
  null
  
)

export default component.exports